import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private cookieService: CookieService) {}
  canActivate(): boolean {
    
    const authCookie = this.cookieService.get('auth');
    
    if (!authCookie) {
      this.router.navigate(['/']);
      return false;
    }
    
    try {
      const extractedData = JSON.parse(window.atob(authCookie));

      if (extractedData.auth) {
        return true;
      }
    } catch (error) {
    }
    
    console.warn('Authentication failed');
    this.router.navigate(['/']);
    return false;
  }
}
